export const setAsteriskServerData = (state, {form}) => {
  state.asteriskServer.form = form
}
export const setJitsiServerData = (state, {form}) => {
  state.jitsiServer.form = null
  state.jitsiServer.form = form
}
export const setJitsiServersList = (state, data) => {
  state.jitsiServersList = data
}